import React from "react";
import Swal from "sweetalert2";

export default function ClearLastDisabledButton({ token, onSuccess }) {
  const handleClick = async () => {
    const confirm = await Swal.fire({
      title: "Clear Data?",
      text: "Proses ini akan menghapus kelompok terakhir / last batch disable_list!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, proses",
      cancelButtonText: "Batal",
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await fetch(
        "https://api.wifikamu.my.id/clear-last-disabled-list",
        {
          headers: { authorization: token },
        }
      );

      const data = await res.json();

      // 404 - Table empty
      if (res.status === 404) {
        return Swal.fire({
          icon: "info",
          title: "Tidak Ada Data",
          text: data.message,
        });
      }

      // 400 - Already older than 15 days
      if (res.status === 400) {
        return Swal.fire({
          icon: "warning",
          title: "Tidak Bisa Hapus",
          html: `
            ${data.message}<br/>
            <strong>Tanggal terakhir:</strong> ${data.last_created_at}
          `,
        });
      }

      // Success
      if (res.ok) {
        Swal.fire({
          icon: "success",
          title: "Berhasil",
          html: `
            ${data.message}<br/>
            <strong>Tanggal terakhir:</strong> ${data.detail.last_created_at}<br/>
            <strong>Selisih Hari:</strong> ${data.detail.diff_days}
          `,
        });

        // Refresh parent
        onSuccess && onSuccess();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: error.message,
      });
    }
  };

  return (
    <button
      onClick={handleClick}
      className="px-3 py-2 rounded bg-red-600 text-white text-sm font-medium hover:bg-red-700"
    >
      Clear Last Batch Disabled List
    </button>
  );
}
